export const HistoryBackDropName = 'HistoryBackDropComponent';
